// src/components/Navbar.jsx
import React, { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./../styles/Navbar.css";
import { clearAuthSession } from "../utils/authSession";

import { ReactComponent as LogoutIcon } from "../Logos To be used/7.svg";

const Navbar = () => {
  const navigate = useNavigate();

  const user = useMemo(() => {
    const name = localStorage.getItem("userName") || "Guest";
    const email = localStorage.getItem("userEmail") || "";
    return { name, email };
  }, []);

  const handleLogout = () => {
    clearAuthSession();
    navigate("/", { replace: true });
  };

  return (
    <div className="nav-menu">
      {/* Part 1 */}
      <div className="nav-section">
        <div className="nav-user-name">{user.name}</div>
        <div className="nav-user-email">{user.email}</div>
      </div>

      <div className="nav-divider" />

      {/* Part 2 */}
      <div className="nav-section">
        <Link className="nav-item nav-item--active" to="/menu#settings">
          Einstellungen
        </Link>

        <div className="nav-item nav-item--disabled">Meine Fächer</div>
        <div className="nav-item nav-item--disabled">Gespeicherte Lektionen</div>
        <div className="nav-item nav-item--disabled">Alt Klausuren</div>
      </div>

      <div className="nav-divider" />

      {/* Part 3 */}
      <div className="nav-section">
        <button
          type="button"
          className="nav-item nav-item--active nav-logout"
          onClick={handleLogout}
        >
          <LogoutIcon className="nav-logout-icon" />
          Abmelden
        </button>
      </div>
    </div>
  );
};

export default Navbar;
